import React from 'react';
import './plastic.scss';

const Plastic = ({ cvc, focused, name, placeholders, onClick, brand, number, expiration }) => (
  <div key="Cards" className="rccs" onClick={onClick}>
    <div
      className={[
        'rccs__card',
        `rccs__card--${brand}`,
        focused === 'cvc' && brand !== 'amex' ? 'rccs__card--flipped' : '',
      ].join(' ').trim()}
    >
      <div className="rccs__card--front">
        <div className="rccs__card__background" />
        <div className="rccs__issuer" />
        <div
          className={[
            'rccs__cvc__front',
            focused === 'cvc' ? 'rccs--focused' : '',
          ].join(' ').trim()}
        >
          {cvc}
        </div>
        <div
          className={[
            'rccs__number',
            number.replace(/ /g, '').length > 16 ? 'rccs__number--large' : '',
            focused === 'number' ? 'rccs--focused' : '',
            number.substr(0, 1) !== '•' ? 'rccs--filled' : '',
          ].join(' ').trim()}
        >
          {number}
        </div>
        <div
          className={[
            'rccs__name',
            focused === 'name' ? 'rccs--focused' : '',
            name ? 'rccs--filled' : '',
          ].join(' ').trim()}
        >
          {name || placeholders.name}
        </div>
        <div
          className={[
            'rccs__expiry',
            focused === 'expiry' ? 'rccs--focused' : '',
            expiration.substr(0, 1) !== '•' ? 'rccs--filled' : '',
          ].join(' ').trim()}
        >
          <div className="rccs__expiry__value">{expiration}</div>
        </div>
        <div className="rccs__chip" />
      </div>
      <div className="rccs__card--back">
        <div className="rccs__card__background" />
        <div className="rccs__stripe" />
        <div className="rccs__signature" />
        <div
          className={[
            'rccs__cvc',
            focused === 'cvc' ? 'rccs--focused' : '',
          ].join(' ').trim()}
        >
          {cvc}
        </div>
        <div className="rccs__issuer" />
      </div>
    </div>
  </div>
);

export default Plastic;
